import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { StaticContext } from '@sm/webassets';
import { SKIP_HREF_LANG_TAGS } from '~pricing/lib/constants';

const HrefLangTags = ({ canonicalPath }) => {
  const {
    environment: { subdomain, domain, tld },
    url,
  } = useContext(StaticContext);
  const hostname = `${subdomain}.${domain}.${tld}`;

  const path = canonicalPath || url;

  const LINKS = [
    {
      lang: 'x-default',
      href: `https://www.${domain}.com${path}`,
    },
    {
      lang: 'en-US',
      href: `https://www.${domain}.com${path}`,
    },
    {
      lang: 'en-GB',
      href: `https://www.${domain}.co.uk${path}`,
    },
    {
      lang: 'de',
      href: `https://www.${domain}.de${path}`,
    },
    {
      lang: 'ru',
      href: `https://www.${domain}.ru${path}`,
    },
    {
      lang: 'es',
      href: `https://es.${domain}.com${path}`,
    },
    {
      lang: 'pt',
      href: `https://pt.${domain}.com${path}`,
    },
    {
      lang: 'nl',
      href: `https://nl.${domain}.com${path}`,
    },
    {
      lang: 'fr',
      href: `https://fr.${domain}.com${path}`,
    },
    {
      lang: 'it',
      href: `https://it.${domain}.com${path}`,
    },
    {
      lang: 'da',
      href: `https://da.${domain}.com${path}`,
    },
    {
      lang: 'sv',
      href: `https://sv.${domain}.com${path}`,
    },
    {
      lang: 'ja',
      href: `https://jp.${domain}.com${path}`,
    },
    {
      lang: 'ko',
      href: `https://ko.${domain}.com${path}`,
    },
    {
      lang: 'zh',
      href: `https://zh.${domain}.com${path}`,
    },
    {
      lang: 'tr',
      href: `https://tr.${domain}.com${path}`,
    },
    {
      lang: 'no',
      href: `https://no.${domain}.com${path}`,
    },
    {
      lang: 'fi',
      href: `https://fi.${domain}.com${path}`,
    },
  ];

  const hrefLangTags = SKIP_HREF_LANG_TAGS[hostname]
    ? null
    : LINKS.map(({ lang, href }) => {
        return <link data-testid="HrefLangTags__Alternate" key={lang} rel="alternate" href={href} hrefLang={lang} />;
      });

  return (
    <>
      <link data-testid="HrefLangTags__Canonical" rel="canonical" href={path} />
      {hrefLangTags}
    </>
  );
};

HrefLangTags.propTypes = {
  canonicalPath: PropTypes.string,
};

HrefLangTags.defaultProps = {
  canonicalPath: null,
};

export default HrefLangTags;
